import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_221 implements Validator {

	public static id = 'CTRL_221';
	private message = 'error.ctr_221';


	public LOG: LogService = new LogService(CTRL_221);
	public formExtractorService: FormExtractorService = new FormExtractorService();


	validate(form: any, map) {


		// vérifier si la règle est applicable sur mon formulaire
		const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_221.id + '_');


		if (rgs.length > 0) {
			for (const rg of rgs) {
				const ctrl = form.controls[rg];
	   const controls =
				this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);

				const firstWithStepId = map.get(ctrl.value.rgCtrls.firstChamp);
				const firstCtrl = form.controls[firstWithStepId];

				if (firstCtrl && (!firstCtrl.value || !this.isCodePostalCorrect(firstCtrl.value))) {
					// placer le message d'erreur
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
				} else {
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
				}
			}
		}
	}

	isCodePostalCorrect(value): boolean{
		return value.match(/^[0-9][0-9][0-9][0-9][0-9]/) && value.length === 5;
	}
}
